import HundredBricksAPI from '@lib/hundredBricksAPI/HundredBricksAPI';
import { APIError } from '@lib/api';
import Post from './Post';
import InvestorFeed from './InvestorFeed';
import InvestorFeedInvalidQueryParam from './InvestorFeedInvalidQueryParam';
import InvestorFeedError from './InvestorFeedError';
import { InvalidPostId, PostAlreadySeen, PostIsNotRegistered, SetPostAsSeenError } from './setPostAsSeen';
class InvestorFeedAPI extends HundredBricksAPI {
    async getInvestorFeed(params) {
        try {
            const { data } = await this.client.get('v2/newsfeed', { params });
            return new InvestorFeed(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                const { perPage, page } = params;
                switch (error.code) {
                    case 'PAGE_CANNOT_BE_LESS_THAN_ONE':
                        throw new InvestorFeedInvalidQueryParam({ page }, { cause: error });
                    case 'PER_PAGE_CANNOT_BE_LESS_THAN_ONE':
                        throw new InvestorFeedInvalidQueryParam({ perPage }, { cause: error });
                    case 'INVALID_PAGE':
                        throw new InvestorFeedInvalidQueryParam({ page }, { cause: error });
                    case 'INVALID_PER_PAGE':
                        throw new InvestorFeedInvalidQueryParam({ perPage }, { cause: error });
                    default:
                        throw new InvestorFeedError({ cause: error });
                }
            }
            else if (error instanceof Error) {
                throw new InvestorFeedError('Unexpected error when obtaining investor feed', { cause: error });
            }
            else {
                throw new InvestorFeedError(`Unexpected error when obtaining investor feed: '${error}'`);
            }
        }
    }
    async setPostAsSeen(postId) {
        try {
            const { data } = await this.client.post(`v2/newsfeed/posts/${postId}/see`);
            return new Post(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVALID_POST_ID':
                        throw new InvalidPostId(postId, { cause: error });
                    case 'POST_NOT_FOUND':
                        throw new PostIsNotRegistered(postId, { cause: error });
                    case 'POST_ALREADY_SEEN':
                        throw new PostAlreadySeen(postId, { cause: error });
                    default:
                        throw new SetPostAsSeenError({ cause: error });
                }
            }
            if (error instanceof Error) {
                throw new SetPostAsSeenError('Unexpected error when is setting post as seen', { cause: error });
            }
            throw new SetPostAsSeenError(`Unexpected error when is setting post as seen: '${error}'`);
        }
    }
}
export default InvestorFeedAPI;
